export const getViewType = ({ ui }) => ui.viewType

export const getFullScreenState = ({ ui }) => ui.fullScreen

export const getNewsState = ({ ui }) => ui.newsState

export const getCurrentEntity = ({ ui }) => ui.currentEntity

export const getBannerVisibility = ({ ui }) => ui.bannerVisible
